export default {
  state: {
    supplierCategoryDialogVisible: false,
    categoryTabs: [],
    categoryActiveTab: null,
    subcategoryTabs: [],
  },
  getters: {
    isSupplierCategoryDialogVisible: (state) => {
      return state.supplierCategoryDialogVisible;
    },
    categoryTabs: (state) => {
      return state.categoryTabs;
    },
    categoryActiveTab: (state) => {
      return state.categoryActiveTab;
    },
    subcategoryTabs: (state) => {
      return state.subcategoryTabs;
    },
  },
  mutations: {
    updateSupplierCategoryDialogVisible(state, value) {
      state.supplierCategoryDialogVisible = value;
    },
    setCategoryActiveTab(state, value) {
      state.categoryActiveTab = value;
    },
    updateSupplierCategoryTabs(state, value) {
      state.categoryTabs = value;
    },
    updateSupplierSubcategoryTabs(state, value) {
      state.subcategoryTabs = value;
    },
  },
};
